import { render } from "./MellonWebECRTransactionRow.vue?vue&type=template&id=6a9bb4aa"
import script from "./MellonWebECRTransactionRow.vue?vue&type=script&lang=js"
export * from "./MellonWebECRTransactionRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__